import React from "react";

const Card = ({ children, className = "", as: Tag = "div", ...rest }) => (
  <Tag className={`provider-beta__card ${className}`.trim()} {...rest}>
    {children}
  </Tag>
);

export default Card;
